import { render, staticRenderFns } from "./HomepageUserCustomization.vue?vue&type=template&id=005b9eac&"
import script from "./HomepageUserCustomization.vue?vue&type=script&lang=js&"
export * from "./HomepageUserCustomization.vue?vue&type=script&lang=js&"
import style0 from "./HomepageUserCustomization.vue?vue&type=style&index=0&id=005b9eac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports